import { FC } from "react";
import { InputNumber, Slider } from "antd";
import { useTranslation } from "react-i18next";
import { formatNumber } from "src/utility";

type Props = {
  min: number;
  max: number;
  value: number;
  currency?: string | null;
  onChange: (value: number) => void;
};

const GiftcardRangeSelector: FC<Props> = ({ min, max, value, currency: itemCurrency, onChange }) => {
  const { t } = useTranslation();
  const currency = itemCurrency ?? t("Giftcards.currencyFallback");
  return (
    <div className="flex flex-col gap-3">
      <span className="text-sm font-medium text-font-default">{t("Giftcards.enterAValue")}</span>
      <InputNumber
        min={min}
        max={max}
        value={value}
        onChange={(v) => v != null && onChange(v)}
        className="w-full! rounded-md! text-lg!"
        suffix={<span className="text-xs text-font-subtle">{currency}</span>}
        formatter={(value) => String(formatNumber(Number(value)) ?? 0)}
        controls={false}
        size="large"
      />
      <div className="flex flex-col gap-1">
        <Slider
          min={min}
          max={max}
          value={value}
          onChange={onChange}
          className="m-0!"
          classNames={{ track: "bg-background-primary!" }}
          tooltip={{ formatter: (v) => `${formatNumber(v ?? 0)} ${currency}` }}
        />
        <div className="flex items-center justify-between text-xs text-font-subtle">
          <span>{t("Giftcards.minValue", { value: `${formatNumber(min)} ${currency}` })}</span>
          <span>{t("Giftcards.maxValue", { value: `${formatNumber(max)} ${currency}` })}</span>
        </div>
      </div>
    </div>
  );
};

export default GiftcardRangeSelector;
